import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  Typography,
  Button,
  Grid,
  CircularProgress,
  IconButton,
  Avatar,
  Divider,
  Stack,
} from "@mui/material";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import MessageCareCoordinatorPopup from "./MessageCareCoordinatorPopup";
import { keyframes } from "@mui/system";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { toast } from "react-toastify";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { useLocation, useNavigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import axios from "api/baseurl";
import DoctorVideoCallModal from "./DoctorVideoCallModal";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import MessagePatientOrCareCoordinatorPopup from "./MessagePatientOrCc";
function ViewPatientCaseReadingsPage() {
  const location = useLocation();
  const navigate = useNavigate();
const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
    const role = loginData?.role;
     const doctor_firstName= loginData?.firstName;
  const doctor_lastName= loginData?.lastName;
  const patientId = location.state?.patientId;
    const [error, setError] = useState("");
  
const [openMessagePopup, setOpenMessagePopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [patientData, setPatientData] = useState(null);
  const [selectedTab, setSelectedTab] = useState("24hours");
    const [selectedPatientId, setSelectedPatientId] = useState(null);
    const [selectedDoctorId, setSelectedDoctorId] = useState(null);
          const [openVideoCall, setOpenVideoCall] = useState(false);
      const [videoRoomName, setVideoRoomName] = useState("");
  const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  const [callNumber, setCallNumber] = useState("");
       const [openCallModal, setOpenCallModal] = useState(false);
    const [openProgressModal, setOpenProgressModal] = useState(false);

  // ================= FETCH API =================
 const [progressNote, setProgressNote] = useState({
      id:"",
      ccid:userid,
      patientid:"",
      notes:"",
      
  
    });
     const handleOpenProgressModal = (patientId) => {
            setSelectedPatientId(patientId);
          
            setProgressNote((prev) => ({
              ...prev,
              patientid: patientId,
              ccid: userid,     // Care coordinator ID from login
            }));
          
            setOpenProgressModal(true);
          };
              const openPhoneCall = (country, phone) => {
            const formatted = `${country}${phone}`;
            setCallNumber(formatted);
            setOpenCallModal(true);
          };
          
          
          
          
              const handleSubmit = async (e) => {
               
               e.preventDefault();
             
              if (!progressNote.notes.trim()) {
              setError("Progress note is required.");
              return;
            }
          
            if (progressNote.notes.trim().length < 3) {
              setError("Progress note must be at least 3 characters.");
              return;
            }
          
              setError(""); // clear error
               setLoading(true);
                 try {
                   
                   const secretKey = await fetchSecretKey();
                 
                   
                   const rawPayload = {
                         id: "",
                        ccid: progressNote.ccid,
                        patientid: progressNote.patientid,
                        notes: progressNote.notes,
                       };
               
                   console.log("Raw Payload Before Encryption:", rawPayload); 
               
                   const encryptedData = encryptBody(rawPayload, secretKey);
               
                   console.log("Encrypted Payload:", encryptedData);
               
                   const token = JSON.parse(localStorage.getItem("loginData")).token;
               
                   // Register Dealer
                   const response = await axios.post("/api/patientnotes/create", encryptedData, {
                     headers: {
                       "Content-Type": "application/json",
                       Authorization: `Bearer ${token}`,
                     },
                   });
               
                  if (response.status === 200) {
            const decryptedResponse = decryptBody(response.data, secretKey);
            console.log("Decrypted Response:", decryptedResponse);
          
            // Backend returns an object, not { success: true }
            if (!decryptedResponse || !decryptedResponse.id) {
              toast.error("Failed to save progress notes.");
              return;
            }
          
            toast.success("Progress Note added successfully!");
          
            // Close modal
            handleCloseProgressModal();
          
            // Optionally refresh list:
            // fetchProgressNotes();
          
          } else {
            toast.error("Failed to save progress notes.");
          }
          
                } catch (error) {
               console.error("Registration Error:", error);
             
               let errorMessage = "Registration failed"; // default message
             
               if (error.response) {
                 const data = error.response.data;
             
                 // ✅ If backend sends a structured JSON with a 'message' field
                 if (typeof data === "object" && data.message) {
                   errorMessage = data.message;
                 } 
                 // ✅ If backend sends a plain text message
                 else if (typeof data === "string") {
                   errorMessage = data;
                 }
               } 
               // ✅ For network or other unexpected errors
               else if (error.message) {
                 errorMessage = error.message;
               }
             
               toast.error(errorMessage);
             } finally {
               setLoading(false);
             }
               };
                 const handleCloseProgressModal = () => {
    setOpenProgressModal(false);
    setSelectedPatientId(null);
    setProgressNote({
  id: "",
  ccid: userid,
  patientid: "",
  notes: "",
});
     setError(""); // reset validation error
  };
  const fetchPatientData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `/api/patientregistration/review/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Patient Reading Data", response.data);

      setPatientData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (patientId) {
      fetchPatientData();
    }
  }, [patientId]);

  // ================= LAST 3 READINGS =================

  const last3GraphData =
    patientData?.last3Readings?.map((item, index) => ({
      name: `R${index + 1}`,

      systolic:
        item?.systolic !== null && item?.systolic !== undefined
          ? item.systolic
          : 0,

      diastolic:
        item?.diastolic !== null && item?.diastolic !== undefined
          ? item.diastolic
          : 0,

      mean:
        item?.systolic && item?.diastolic
          ? Math.round(
              (item.systolic + 2 * item.diastolic) / 3
            )
          : 0,

      sugar:
        item?.spo2 !== null && item?.spo2 !== undefined
          ? item.spo2
          : 0,

      fullDate: item?.recordedAt
        ? new Date(item.recordedAt).toLocaleDateString()
        : "",
    })) || [];

  // ================= VITALS HISTORY =================

  const vitalsData =
    selectedTab === "24hours"
      ? patientData?.last24HoursVitals?.map((item, index) => ({
          time: `${index + 1}`,

          systolic:
            item?.bpSystolic !== null &&
            item?.bpSystolic !== undefined
              ? item.bpSystolic
              : 0,

          diastolic:
            item?.bpDiastolic !== null &&
            item?.bpDiastolic !== undefined
              ? item.bpDiastolic
              : 0,

          mean:
            item?.bpMean !== null &&
            item?.bpMean !== undefined
              ? item.bpMean
              : 0,

          sugar:
            item?.randomSugar !== null &&
            item?.randomSugar !== undefined
              ? item.randomSugar
              : 0,

          fullDate: item?.recordedAt
            ? new Date(item.recordedAt).toLocaleDateString()
            : "",
        }))
      : patientData?.sevenDayTrend?.map((item, index) => ({
          time: `D${index + 1}`,

          systolic:
            item?.bpSystolic !== null &&
            item?.bpSystolic !== undefined
              ? item.bpSystolic
              : 0,

          diastolic:
            item?.bpDiastolic !== null &&
            item?.bpDiastolic !== undefined
              ? item.bpDiastolic
              : 0,

          mean:
            item?.bpMean !== null &&
            item?.bpMean !== undefined
              ? item.bpMean
              : 0,

          sugar:
            item?.randomSugar !== null &&
            item?.randomSugar !== undefined
              ? item.randomSugar
              : 0,

          fullDate: item?.recordedAt
            ? new Date(item.recordedAt).toLocaleDateString()
            : "",
        })) || [];

  // ================= TOOLTIP =================

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Card
          sx={{
            p: 1.5,
            borderRadius: "14px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          }}
        >
          <Typography fontSize="12px" fontWeight="600">
            {label}
          </Typography>

          <Typography fontSize="12px">
            BP Systolic : {payload[0]?.value}
          </Typography>

          <Typography fontSize="12px">
            BP Diastolic : {payload[1]?.value}
          </Typography>

          <Typography fontSize="12px">
            BP Mean : {payload[2]?.value}
          </Typography>

          <Typography fontSize="12px">
            Sugar : {payload[3]?.value}
          </Typography>
        </Card>
      );
    }

    return null;
  };
const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
    const dotPositions = [
        { top: "5%", left: "50%" },
        { top: "20%", left: "80%" },
        { top: "50%", left: "95%" },
        { top: "80%", left: "80%" },
        { top: "95%", left: "50%" },
        { top: "80%", left: "20%" },
        { top: "50%", left: "5%" },
        { top: "20%", left: "20%" },
    ];

    const notifyPatientForVideoCall = async (patientId, roomName) => {
      try {
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        await axios.post(
          "/api/video-call/start",
          { patientId, roomName },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } catch (error) {
        console.error("Failed to notify patient", error);
      }
    };
    
    const generateSecureRoomName = (doctorId, patientId) => {
      const timestamp = Date.now().toString(36);
    
      const randomArray = new Uint32Array(2);
      window.crypto.getRandomValues(randomArray);
    const randomString = Array.from(randomArray)
        .map((num) => num.toString(36))
        .join("");
    
    
      return `doctor-patient-${doctorId}-${patientId}-${timestamp}-${randomString}`;
    };
    const sosIconStyle = {
  color: "#d32f2f",
  backgroundColor: "rgba(211, 47, 47, 0.08)",
  "&:hover": {
    backgroundColor: "#d32f2f",
    color: "#fff",
    transform: "scale(1.05)",
  },
  transition: "all 0.3s ease",
};
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading ? (
        <Box
         sx={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                zIndex: 9999,
                            }}
        >
             <Box
                                          sx={{
                                              position: "relative",
                                              width: 80,
                                              height: 80,
                                              animation: `${spinAnimation} 1.5s linear infinite`,
                                          }}
                                      >
                                          {dotPositions.map((pos, index) => (
                                              <Box
                                                  key={index}
                                                  sx={{
                                                      width: 8,
                                                      height: 8,
                                                      borderRadius: "50%",
                                                      backgroundColor: "#1A237E",
                                                      position: "absolute",
                                                      ...pos,
                                                  }}
                                              />
                                          ))}
                                      </Box> </Box>
      ) : (
        <Box
          sx={{
            maxWidth: "1000px",
            margin: "0 auto",
            pb: 5,
          }}
        >
          {/* ================= HEADER ================= */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 3,
              mt: 1,
            }}
          >
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <ArrowBackIosNewIcon
                sx={{
                  fontSize: "18px",
                }}
              />
            </IconButton>

            <Typography
              sx={{
                flex: 1,
                textAlign: "center",
                fontWeight: 700,
                fontSize: "28px",
                color: "#1A237E",
                mr: 5,
              }}
            >
              Patient Readings
            </Typography>
          </Box>

          {/* ================= PATIENT CARD ================= */}

          <Card
            sx={{
              borderRadius: "24px",
              p: 3,
              mb: 3,
              background:
                "linear-gradient(135deg, #ffffff 0%, #f7f9ff 100%)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{
                  width: 72,
                  height: 72,
                  background:
                    "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
                  fontSize: "28px",
                  fontWeight: 700,
                  mr: 2.5,
                }}
              >
                {patientData?.patientName?.charAt(0)}
              </Avatar>

              <Box flex={1}>
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: 700,
                    color: "#111",
                    textTransform: "capitalize",
                  }}
                >
                  {patientData?.patientName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "15px",
                    color: "#666",
                    mt: 0.5,
                    fontWeight: 500,
                  }}
                >
                  {patientData?.age} Years • {patientData?.gender}
                </Typography>
              </Box>
            </Box>
          </Card>

          {/* ================= LAST 3 READINGS ================= */}

          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#111",
              mb: 2,
            }}
          >
            Last 3 Readings
          </Typography>

          <Card
            sx={{
              borderRadius: "24px",
              p: 3,
              mb: 3,
              boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
            }}
          >
            <ResponsiveContainer width="100%" height={350}>
              <LineChart data={last3GraphData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke="#ececec"
                />

                <XAxis
                  dataKey="fullDate"
                  tick={{
                    fontSize: 12,
                    fill: "#777",
                  }}
                />

                <YAxis
                  tick={{
                    fontSize: 12,
                    fill: "#777",
                  }}
                />

                <Tooltip content={<CustomTooltip />} />

                <Legend />

                <Line
                  type="monotone"
                  dataKey="systolic"
                  stroke="#ef4444"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Systolic"
                />

                <Line
                  type="monotone"
                  dataKey="diastolic"
                  stroke="#3b82f6"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Diastolic"
                />

                <Line
                  type="monotone"
                  dataKey="mean"
                  stroke="#10b981"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Mean"
                />

                <Line
                  type="monotone"
                  dataKey="sugar"
                  stroke="#8b5cf6"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="Sugar"
                />
              </LineChart>
            </ResponsiveContainer>
          </Card>

          {/* ================= VITALS HISTORY ================= */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                color: "#111",
              }}
            >
              Vitals History
            </Typography>

            <Stack direction="row" spacing={1}>
              <Button
                onClick={() => setSelectedTab("24hours")}
                variant={
                  selectedTab === "24hours"
                    ? "contained"
                    : "outlined"
                }
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  px: 2.5,
                  fontWeight: 600,
                  backgroundColor:
                    selectedTab === "24hours"
                      ? "#5E35B1"
                      : "#fff",

                  borderColor: "#5E35B1",

                  color:
                    selectedTab === "24hours"
                      ? "#fff"
                      : "#5E35B1",
                }}
              >
                24 Hours
              </Button>

              <Button
                onClick={() => setSelectedTab("7days")}
                variant={
                  selectedTab === "7days"
                    ? "contained"
                    : "outlined"
                }
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  px: 2.5,
                  fontWeight: 600,
                  backgroundColor:
                    selectedTab === "7days"
                      ? "#5E35B1"
                      : "#fff",

                  borderColor: "#5E35B1",

                  color:
                    selectedTab === "7days"
                      ? "#fff"
                      : "#5E35B1",
                }}
              >
                7 Days
              </Button>
            </Stack>
          </Box>

          {/* ================= HISTORY GRAPH ================= */}

          <Card
            sx={{
              borderRadius: "24px",
              p: 3,
              mb: 3,
              boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
            }}
          >
            <ResponsiveContainer width="100%" height={420}>
              <LineChart data={vitalsData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke="#ececec"
                />

                <XAxis
                  dataKey="fullDate"
                  tick={{
                    fontSize: 12,
                    fill: "#777",
                  }}
                />

                <YAxis
                  tick={{
                    fontSize: 12,
                    fill: "#777",
                  }}
                />

                <Tooltip content={<CustomTooltip />} />

                <Legend />

                <Line
                  type="monotone"
                  dataKey="systolic"
                  stroke="#ef4444"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Systolic"
                />

                <Line
                  type="monotone"
                  dataKey="diastolic"
                  stroke="#3b82f6"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Diastolic"
                />

                <Line
                  type="monotone"
                  dataKey="mean"
                  stroke="#10b981"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="BP Mean"
                />

                <Line
                  type="monotone"
                  dataKey="sugar"
                  stroke="#8b5cf6"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                  activeDot={{ r: 8 }}
                  name="Sugar"
                />
              </LineChart>
            </ResponsiveContainer>
          </Card>

          {/* ================= NOTES ================= */}

          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#111",
              mb: 2,
            }}
          >
            Coordinator Notes
          </Typography>

          <Card
            sx={{
              borderRadius: "24px",
              p: 3,
              mb: 3,
              boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
            }}
          >
            {patientData?.careCoordinatorNotes?.map(
              (note, index) => (
                <Box key={index}>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "#333",
                      lineHeight: 1.8,
                      fontWeight: 500,
                    }}
                  >
                    {note.notes}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#888",
                      mt: 1,
                    }}
                  >
                    {new Date(
                      note.createdTime
                    ).toLocaleString()}
                  </Typography>

                  {index !==
                    patientData.careCoordinatorNotes.length -
                      1 && (
                    <Divider
                      sx={{
                        my: 2,
                      }}
                    />
                  )}
                </Box>
              )
            )}
          </Card>
<Typography
  sx={{
    fontSize: "18px",
    fontWeight: 700,
    color: "#111827",
    mb: 2,
  }}
>
  Post Consultation Notes
</Typography>

<Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      md: "1fr 1fr 1fr",
    },
    gap: 2,
  }}
>
  {patientData?.doctorNotes?.map((note, index) => (
    <Card
      key={note.id || index}
      sx={{
        borderRadius: "18px",
        p: 2,
        background: "#fff",
        border: "1px solid #eef2f7",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        transition: "0.3s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#1A237E",
          }}
        >
          Consultation #{index + 1}
        </Typography>

        <Typography
          sx={{
            fontSize: "11px",
            color: "#888",
          }}
        >
          {note?.createdAt
            ? new Date(note.createdAt).toLocaleDateString()
            : "-"}
        </Typography>
      </Box>

      {/* Diagnosis */}
      <Box sx={{ mb: 1.5 }}>
        <Typography
          sx={{
            fontSize: "11px",
            color: "#6b7280",
            fontWeight: 600,
            mb: 0.3,
          }}
        >
          Diagnosis
        </Typography>

        <Typography
          sx={{
            fontSize: "13px",
            color: "#111827",
            fontWeight: 500,
          }}
        >
          {note?.diagnosis || "-"}
        </Typography>
      </Box>

      {/* Instructions */}
      <Box sx={{ mb: 1.5 }}>
        <Typography
          sx={{
            fontSize: "11px",
            color: "#6b7280",
            fontWeight: 600,
            mb: 0.3,
          }}
        >
          Instructions
        </Typography>

        <Typography
          sx={{
            fontSize: "12px",
            color: "#374151",
            lineHeight: 1.6,
          }}
        >
          {note?.instructions || "-"}
        </Typography>
      </Box>

      {/* Medications */}
      <Box sx={{ mb: 1.5 }}>
        <Typography
          sx={{
            fontSize: "11px",
            color: "#6b7280",
            fontWeight: 600,
            mb: 0.5,
          }}
        >
          Medications
        </Typography>

        {note?.medications?.length > 0 ? (
          note.medications.map((med, medIndex) => (
            <Typography
              key={medIndex}
              sx={{
                fontSize: "12px",
                color: "#374151",
                mb: 0.3,
              }}
            >
              • {med}
            </Typography>
          ))
        ) : (
          <Typography
            sx={{
              fontSize: "12px",
              color: "#9ca3af",
            }}
          >
            No medications
          </Typography>
        )}
      </Box>

      {/* Bottom Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
          pt: 1.5,
          borderTop: "1px solid #f1f5f9",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "10px",
              color: "#9ca3af",
              fontWeight: 600,
            }}
          >
            FOLLOW UP
          </Typography>

          <Typography
            sx={{
              fontSize: "12px",
              color: "#111827",
              fontWeight: 600,
            }}
          >
            {note?.followUp || "-"}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: "20px",
            backgroundColor:
              note?.decision === "ESCALATE"
                ? "#fee2e2"
                : "#dcfce7",
          }}
        >
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color:
                note?.decision === "ESCALATE"
                  ? "#dc2626"
                  : "#16a34a",
            }}
          >
            {note?.decision || "-"}
          </Typography>
        </Box>
      </Box>

      {/* Escalation Reason */}
      {note?.escalationReason && (
        <Box
          sx={{
            mt: 1.5,
            p: 1.2,
            borderRadius: "10px",
            backgroundColor: "#fff7ed",
          }}
        >
          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: 700,
              color: "#ea580c",
              mb: 0.3,
            }}
          >
            ESCALATION REASON
          </Typography>

          <Typography
            sx={{
              fontSize: "11px",
              color: "#7c2d12",
              lineHeight: 1.5,
            }}
          >
            {note.escalationReason}
          </Typography>
        </Box>
      )}
    </Card>
  ))}
</Box>
          {/* ================= ACTION BUTTONS ================= */}
<br/>
          <Grid container spacing={2}>
           <Grid item xs={6} sm={2}>
  <Button
    fullWidth
    startIcon={
      <VideocamRoundedIcon
        sx={{
          fontSize: 20,
          color: "#fff",
        }}
      />
    }
    variant="contained"
    onClick={(e) => {
      e.stopPropagation();

      const room = generateSecureRoomName(
        userid,
        patientData?.patientId
      );

      setVideoRoomName(room);

      setSelectedPatientId(
        patientData?.patientId
      );

      setSelectedDoctorId(userid);

      setOpenVideoCall(true);

      notifyPatientForVideoCall(
        patientData?.patientId,
        room
      );
    }}
    sx={{
      py: 1.5,
      borderRadius: "16px",
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 600,
      background:
        "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
      color: "#fff",

      "& .MuiButton-startIcon": {
        marginRight: "8px",
      },

      "&:hover": {
        background:
          "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
      },
    }}
  >
    Video Call
  </Button>
</Grid>

            <Grid item xs={6} sm={2}>
              <Button
                fullWidth
                startIcon={<CallRoundedIcon />}
                variant="contained"
                sx={{
                  py: 1.5,
                  borderRadius: "16px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
                  color: "#fff",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
                  },
                }}
              >
                Audio Call
              </Button>
            </Grid>

  <Grid item xs={6} sm={2}>
    <Button
      fullWidth
      startIcon={
        <AssignmentTurnedInRoundedIcon />
      }
      variant="contained"
      onClick={() =>
        navigate("/RenderingPostConsultationPage", {
          state: {
            patientId: patientData?.patientId,
              patientUserId: patientData?.patientUserId,
          },
        })
      }

      sx={{
        py: 0.5,
        borderRadius: "16px",
        textTransform: "none",
        fontSize: "12px",
        fontWeight: 600,
        background:
          "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
        color: "#fff",

        "&:hover": {
          background:
            "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
        },
      }}
    >
      Post Consultation
    </Button>
  </Grid>
   <Grid item xs={6} sm={2}>
    <Button
      fullWidth
      startIcon={
        <AssignmentTurnedInRoundedIcon />
      }
      variant="contained"
      onClick={() =>
        navigate("/RenderingPrescriptionPage", {
          state: {
            patientId: patientData?.patientId,
              patientUserId: patientData?.patientUserId,
              DoctorId:patientData?.doctorid,
          },
        })
      }
      sx={{
        py: 1.5,
        borderRadius: "16px",
        textTransform: "none",
        fontSize: "12px",
        fontWeight: 600,
        background:
          "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
        color: "#fff",

        "&:hover": {
          background:
            "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
        },
      }}
    >
      Prescription
    </Button>
  </Grid>
            <Grid item xs={6} sm={2}>
              <Button
                fullWidth
                startIcon={<ChatBubbleOutlineRoundedIcon />}
                variant="outlined"
                  onClick={() => setOpenMessagePopup(true)}
                sx={{
                  py: 1.5,
                  borderRadius: "16px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderColor: "#5E35B1",
                  color: "#5E35B1",

                  "&:hover": {
                    borderColor: "#512DA8",
                    backgroundColor: "#f5f2ff",
                  },
                }}
              >
                Message
              </Button>
            </Grid>

            <Grid item xs={6} sm={2}>
             <Button
               fullWidth
               startIcon={<FolderOpenRoundedIcon />}
               variant="outlined"
               onClick={() =>
                 navigate(`/full-case/${patientId}`)
               }
               sx={{
                 py: 1.5,
                 borderRadius: "16px",
                 textTransform: "none",
                 fontSize: "14px",
                 fontWeight: 600,
                 borderColor: "#5E35B1",
                 color: "#5E35B1",
           
                 "&:hover": {
                   borderColor: "#512DA8",
                   backgroundColor: "#f5f2ff",
                 },
               }}
             >
               Full Case
             </Button>
           </Grid>
                     </Grid>
        </Box>
      )}
       {openVideoCall && (
                          <DoctorVideoCallModal
                            open={openVideoCall}
                            onClose={() => setOpenVideoCall(false)}
                            roomName={videoRoomName}
                             doctorId={selectedDoctorId}
                      patientId={selectedPatientId}
                      userName={`${doctor_firstName || ""} ${doctor_lastName || ""}`}
                          />
                        )}
      <MessagePatientOrCareCoordinatorPopup
  open={openMessagePopup}
  handleClose={() => setOpenMessagePopup(false)}
  patientId={patientData?.patientId}
  CcId={patientData?.ccid}
 
/>
    </DashboardLayout>
  );
}

export default ViewPatientCaseReadingsPage;